import constants from "@/config/config.js";
import Eye from "vue-material-design-icons/Eye.vue";
import CheckCircleOutline from "vue-material-design-icons/CheckCircleOutline.vue";

export default {
  components: {
    "poliza-icon": Eye,
    "active-icon": CheckCircleOutline
  },
  data() {
    return {
      unidades: null,
      currentPage: 1,
      items: [],
      fields: [
        { key: "economico", label: "Económico" },
        { key: "marca", label: "Marca" },
        { key: "modelo", label: "Modelo" },
        { key: "claveAsegurado", label: "Clave Asegurado" },
        { key: "poliza", label: "Póliza" },
        { key: "socio", label: "Socio" },
        { key: "activo", label: "Activo" }
      ],
      entradas: [10, 20, 30],
      entrada: null,
      selected: false,
      filter: null,
      poliza: null,
      isBusy: false,
      isEmpty: false,
      isDisabled: false,
      rows: 1
    };
  },
  // Antes de que se cree el componente, se ejecuta el método de obtener cobranza unidades
  mounted() {
    this.getUnidades();
    this.entrada = this.entradas[0].toString();
  },
  watch: {
    currentPage: {
      handler: function() {
        this.items = [];
        if (this.filter) {
          this.getFilter();
        } else {
          this.getUnidades();
        }
      }
    },
    selected: {
      handler: function() {
        this.perPage = this.entrada;
        this.items = [];
        if (this.filter) {
          this.getFilter();
        } else {
          this.getUnidades();
        }
      }
    },
    filter: {
      handler: function() {
        this.perPage = this.entrada;
        this.items = [];
        this.getFilter();
      }
    }
  },
  computed: {
    perPage: {
      get: function() {
        if (this.selected) {
          return this.entrada;
        } else {
          return (this.entrada = "10");
        }
      },
      set: function() {
        if (this.selected) {
          return this.entrada;
        } else {
          return (this.entrada = "10");
        }
      }
    }
  },
  methods: {
    async getUnidades() {
      // Mostrar mensaje de cargando en la página si es que no se muestran los datos aún en la tabla
      this.isDisabled = true;
      this.isBusy = true;
      const { status, data } = await this.Api.get(
        `unidades?perPage=${this.perPage}&page=${this.currentPage}`
      );
      if (status) {
        this.rows = data.total;
        this.unidades = data.data;
        this.unidades.sort(this.orderArrayOfObjects("economico"));
        this.unidades.forEach(unidad => {
          let socio = `${unidad.socioNombre} ${unidad.socioApellidoPaterno}`;
          let polizaURL = unidad.poliza
            ? `${constants.apiEndPoint}${unidad.poliza}`
            : require("../../img/INE_default.png");
          unidad = {
            economico: unidad.economico,
            marca: unidad.marca,
            modelo: unidad.modelo,
            claveAsegurado: unidad.claveAsegurado,
            poliza: polizaURL,
            socio,
            activo: unidad.activo
          };
          this.items.push(unidad);
        });
        if (this.items.length === 0) {
          this.isEmpty = true;
          this.isDisabled = true;
        }
      }
      this.isBusy = false;
      this.isDisabled = false;
    },
    async getFilter() {
      if (this.filter) {
        this.items = [];
        // Mostrar mensaje de cargando en la página si es que no se muestran los datos aún en la tabla
        this.isBusy = true;
        const { status, data } = await this.Api.get(
          `unidades?buscar=${this.filter}&perPage=${this.perPage}&page=${this.currentPage}`
        );
        if (status) {
          this.unidades = data.data;
          this.rows = data.total;
          this.unidades.forEach(unidad => {
            let socio = `${unidad.socioNombre} ${unidad.socioApellidoPaterno}`;
            let polizaURL = unidad.poliza
              ? `${constants.apiEndPoint}${unidad.poliza}`
              : require("../../img/INE_default.png");
            unidad = {
              economico: unidad.economico,
              marca: unidad.marca,
              modelo: unidad.modelo,
              claveAsegurado: unidad.claveAsegurado,
              poliza: polizaURL,
              socio,
              activo: unidad.activo
            };
            this.items.push(unidad);
          });
          if (this.items.length === 0) {
            this.isEmpty = true;
          }
        }
        this.isBusy = false;
      } else {
        this.items = [];
        this.perPage = 10;
        this.entrada = "10";
        this.getUnidades();
      }
    },
    showText(entrada) {
      if (this.selected) {
        this.items = [];
        this.perPage = entrada;
        this.entrada = entrada;
        if (this.filter) {
          this.getFilter();
        } else {
          this.getUnidades();
        }
      }
      return (this.entrada = entrada.toString());
    },
    showModal(data) {
      this.poliza = data;
    },
    filterArrayOfObjects(items) {
      let distinctArray = Array.from(new Set(items.map(s => s.id))).map(id => {
        return {
          id: id,
          nombre: items.find(s => s.id === id).nombre
        };
      });
      return distinctArray;
    },
    orderArrayOfObjects(key, order = "asc") {
      return function innerSort(a, b) {
        if (
          !Object.prototype.hasOwnProperty.call(a, key) ||
          !Object.prototype.hasOwnProperty.call(b, key)
        ) {
          // property doesn't exist on either object
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order === "desc" ? comparison * -1 : comparison;
      };
    }
  }
};
